export function setViewportSizeVariables(update = false) {
  const { outerHeight, outerWidth } = window;
  const visualHeight = visualViewport?.height || outerHeight;

  const docStyle = document.documentElement.style;

  const viewport = {
    width: docStyle.getPropertyValue('--innerWidth'),
    height: docStyle.getPropertyValue('--innerHeight'),
  };

  const hasInitialViewSize = !!outerWidth && !!visualHeight && !!viewport.width && !!viewport.height;

  if (hasInitialViewSize && !update) return;

  outerWidth && docStyle.setProperty(
    '--innerWidth',
    `${outerWidth}px`,
  );

  visualHeight && docStyle.setProperty(
    '--innerHeight',
      `${visualHeight}px`
  );
}

export function switchViewportSizeVariables() {
  const docStyle = document.documentElement.style;

  const viewport = {
    width: docStyle.getPropertyValue('--innerWidth'),
    height: docStyle.getPropertyValue('--innerHeight'),
  };

  viewport.height && docStyle.setProperty(
    '--innerWidth',
    `${viewport.height}`,
  );

  viewport.width && docStyle.setProperty(
    '--innerHeight',
    `${viewport.width}`,
  );
}
